import React from 'react';

export const ChevronUp = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.35081 7.76833L6.90998 10.2308C6.7543 10.3882 6.66699 10.6007 6.66699 10.8221C6.66699 11.0435 6.7543 11.2559 6.90998 11.4133C6.98643 11.491 7.07756 11.5526 7.17806 11.5947C7.27857 11.6368 7.38644 11.6584 7.49539 11.6584C7.60435 11.6584 7.71222 11.6368 7.81272 11.5947C7.91322 11.5526 8.00435 11.491 8.08081 11.4133L9.99581 9.4825L11.9183 11.4217C11.995 11.4992 12.0863 11.5608 12.1869 11.6029C12.2875 11.6449 12.3955 11.6666 12.5046 11.6666C12.6136 11.6666 12.7216 11.6449 12.8222 11.6029C12.9229 11.5608 13.0142 11.4992 13.0908 11.4217C13.2463 11.2642 13.3335 11.0517 13.3335 10.8304C13.3335 10.6091 13.2463 10.3967 13.0908 10.2392L10.6408 7.76833C10.4685 7.59691 10.2355 7.50047 9.99248 7.5C9.75998 7.5 9.52831 7.58917 9.35081 7.76833Z"
      fill="#42526E"
    />
  </svg>
);
